// TODO: to keep one style for naming controllers for directive.
/**
 * @name results.controller:directiveTicker
 * @description
 * # directiveTicker
 * Implementation of ticker using jquery.marquee plugin
 */
export default function ($scope, $element) {
    'ngInject';

    /**
     * Configuration for jquery.marquee plugin
     * @type object
     */
    $scope.config = {
        delayBeforeStart: 0,
        duplicated: true,
        gap: 100
    };

    /**
     * Is ticker is playing or stopped
     * @type boolean
     */
    $scope.isTickerPlaying = true;

    /**
     * Content of ticker
     * @type object
     */
    $scope.$content = $element.find('#marquee');

    /**
     * Getter for $scope.isTickerPlaying
     */
    $scope.getIsTickerPlaying = () => $scope.isTickerPlaying;

    /**
     * Setter for $scope.isTickerPlaying
     */
    $scope.setIsTickerPlaying = (value) => {
        $scope.isTickerPlaying = value;
    };

    /**
     * Initializes ticker
     */
    $scope.init = () => {
        $scope.$content.html($scope.directiveTickerText);
        $scope.$content.marquee($scope.config);
        $scope.$content.marquee('play');
        // Force initial position from start of the block
        $scope.$content.find('.js-marquee-wrapper').css({
            'margin-left': 0
        }).attr('data-test-selector', 'block-tickerText');
    };

    /**
     * Switching between playing and paused state of ticker
     */
    $scope.toggleTicker = () => {
        $scope.$content.marquee('toggle');

        $scope.setIsTickerPlaying(!$scope.getIsTickerPlaying());
    };

    $scope.init();
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveTicker.js